export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "utm_partner",
]

export const getUTMParams = () => {
  const utmParams = {}
  UTM_KEYS.forEach(key => {
    const value = sessionStorage.getItem(key)
    if (value) {
      utmParams[key] = value
    }
  })
  return utmParams
}
